import {Component} from "react";
import React from "react";
import {events} from "../../helpers/Events";
import {FormValidator} from "./FormValidator";
import {FormAddressAutocomplete} from "./FormAddressAutocomplete";

/**
 * React component for the buttons in the footer
 * Also handles switching pages and validating the
 * form
 */
export class FormFooterComponent extends Component {

    constructor(props) {
        super(props);
        this.$steps = this.props.$form.find('.c-form-step');
        this.state = {page: props.initialPage, saving: false};
        this.validator = new FormValidator(this.props.$form);
        new FormAddressAutocomplete();
    }

    /**
     * Check if the form is valid and in that case save the form
     */
    onNext() {
        if (this.validator.check.form()) this.saveForm();
    }

    /**
     * Send the form to the backend to be stored in session or
     * send to an Api
     */
    saveForm() {
			  this.setState({saving: true});

        const postArguments = {
            action: 'edpress_action',
            service: this.props.service,
            method: 'ajaxSave',
            nonce: wp.ajax_nonce
        };

        // loop over the form and add its values to the postArguments
        $.each(this.props.$form.serializeArray(), (key, obj) => {
            if (obj.name.includes('[]')) {
                const name = obj.name.replace('[]','');
                if (postArguments[name]) {
                    postArguments[name].push(obj.value);
                } else {
                    postArguments[name] = [obj.value];
                }
            } else {
                postArguments[obj.name] = obj.value;
            }
        });

        // post form and show errors of go to the next page
        $.post(
          wp.ajaxurl,
          postArguments,
          /* istanbul ignore next */ error => this.handleFormPostResponse(error)
        );
    }

	/**
   * If the form is valid proceed to the next page
   * otherwise display the error
	 * @param error
	 */
	handleFormPostResponse(error) {
		  this.setState({saving: false});
			if (error) {
				this.validator.showError(error);
			} else {
				this.goTo(parseInt(this.state.page) + 1);
			}
    }

    /**
     * Passed all validation
     *
     * Emits an switchFormPage event for other components (like the FormStepper)
     * Stores the current page in the session storage so we can refresh the page
     * and continue where we left of
     * @param step
     */
    goTo(step) {
        this.validator.hideErrors();
        events.emit('SwitchFormPage', step);
        this.setState({page: step});
        window.sessionStorage.setItem(this.props.service + 'FormPage', step);
    }

    /**
     * Show next step and hide old validation errors
     *
     * because we have a very large form in twig and we don't want to write
     * this in react we activate the steps using jquery
     */
    showStep(index) {
        this.$steps.hide();
        this.$steps.eq(index).show();
    }

    /**
     * Renders the footer of the form with the required buttons
     * @returns {*}
     */
    render() {
        const {pages} = this.props;

        this.showStep(this.state.page);

        return (
            <div className="c-form-page__footer d-flex">
                {this.state.page > 0 &&
                    <span className="ui-btn ui-btn--primary js-prev-step"
                          onClick={() => this.goTo(this.state.page - 1)}>
                        Vorige
                    </span>
                }
                {this.state.page < pages.length - 1 &&
                    <span className="ui-btn ui-btn--primary js-next-step ml-auto"
                          onClick={(e) => this.onNext(e)}>
                        Verder
											{this.state.saving === true && <i className="fa fa-spinner fa-spin"></i>}
                    </span>
                }
                {this.state.page === pages.length - 1 &&
                    <button type="submit"
                           className="ui-btn ui-btn--primary js-next-step ml-auto">
                        Aanmelden
                    </button>
                }
            </div>
        )
    }
}
